// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';

// Styles
import '../../styles/filter.css';

export default class Trail extends React.Component {
    useDarkMode = localStorage.getItem('theme') === 'dark';

    render = () => {
        return (
            <div
                className='filter-container'
            >
                 {
                this.props.filterCount > 0 && 
                <>
                    <div
                        className='filter-clear-all a'
                        onClick={this.props.onClear}
                    >
                        Clear all
                    </div>
                    <div className='filter-count'>{this.props.filterCount}</div>
                </>
                }
                <div 
                    className='filter-label'
                    style={{backgroundImage: "url(https://static.stax.ai/images/nav/" + (this.useDarkMode ? "dark/" : "") + "filter.png)",}}
                    onClick={this.props.onClick}    
                >
                    {this.props.label??"Filter"}
                </div>
            </div>
        );
    }
}